import { useState } from 'react';

import { ViewContainer } from '@web/components/ui/view-container'; // <-- New container

import { DoctorsTable } from './list/doctors-table';

import { Route } from '..';
import { Filter } from '@web/components/ui/view-filters';
import { trpc } from '@web/lib/trpc';
import { DoctorDetailsView } from './details/doctors-details-view';

import { CreateDoctorDialog } from '@web/routes/dashboard/admin/doctors/-components/details/create-doctor-dialog';

export function DoctorInterface() {
  const navigate = Route.useNavigate();

  const [selectedDoctorId, setSelectedDoctorId] = useState<string | null>(null);

  const [createDoctorDialogOpen, setCreateDoctorDialogOpen] =
    useState<boolean>(false);

  const { firstName, lastName, status } = Route.useSearch();

  const { data: doctorsData, refetch: refetchDoctorsData } =
    trpc.doctor.listAll.useQuery();

  const filteredDoctors = doctorsData?.filter((doctor) => {
    if (
      firstName &&
      !doctor.displayName.toLowerCase().includes(firstName.toLowerCase())
    )
      return false;
    if (
      lastName &&
      !doctor.displayName.toLowerCase().includes(lastName.toLowerCase())
    )
      return false;
    if (status !== undefined && doctor.status !== status) return false;

    return true;
  });

  const filters = [
    {
      key: 'firstName',
      label: 'First Name',
      type: 'string',
      value: firstName,
      isMainFilter: true,
    },
    {
      key: 'lastName',
      label: 'Last Name',
      type: 'string',
      value: lastName,
      isMainFilter: true,
    },
    {
      key: 'status',
      label: 'Status',
      type: 'enum',
      value: status,
      options: ['active', 'inactive', 'any'],
    },
  ] as const satisfies Filter[];

  const onFilterChange = (
    newSearch: Record<string, string | number | boolean | object | undefined>,
  ) => {
    void navigate({
      search: (current) => ({ ...current, ...newSearch }),
    });
  };

  return (
    <div>
      <ViewContainer
        title="Doctors"
        addButtonLabel="Add Doctor"
        onAddButtonClick={() => {
          setCreateDoctorDialogOpen(true);
        }}
        filters={filters}
        onFilterChange={onFilterChange}
      >
        {/* Your table or any other content goes here */}
        <DoctorsTable
          doctors={filteredDoctors}
          onDetails={({ id }) => {
            console.log('onDetails', id);
            setSelectedDoctorId(id);
          }}
        />
      </ViewContainer>

      {/* Dialog for editing doctors */}
      {selectedDoctorId !== null && (
        <DoctorDetailsView
          doctorId={selectedDoctorId}
          onClose={() => {
            setSelectedDoctorId(null);

            void refetchDoctorsData();
          }}
        />
      )}

      {/* Dialog for creating doctors */}
      {createDoctorDialogOpen && (
        <CreateDoctorDialog
          onClose={() => {
            setCreateDoctorDialogOpen(false);
            void refetchDoctorsData();
          }}
        />
      )}
    </div>
  );
}
